/**
 * @generated SignedSource<<df09ebcd9c44ccd5ddf739d32c7bdd30>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AsanaTaskEventQuery$variables = {
  orgRelayId: string;
  externalEventId: string;
  calendarId: string;
};
export type AsanaTaskEventQuery$data = {
  readonly org: {
    readonly __typename: string;
    readonly id: string;
    readonly primaryOrgCalendar?: string;
    readonly forceFetchEventParentErrorable?: {
      readonly __typename: "EventParent";
      readonly id: string;
      readonly events: ReadonlyArray<{
        readonly id: string;
        readonly eventKey: {
          readonly externalEventId: string;
        };
        readonly organizer: {
          readonly urnValue: string;
        } | null;
      }>;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
  } | null;
};
export type AsanaTaskEventQuery = {
  variables: AsanaTaskEventQuery$variables;
  response: AsanaTaskEventQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "calendarId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "externalEventId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orgRelayId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "orgRelayId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryOrgCalendar",
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "calendarId",
    "variableName": "calendarId"
  },
  {
    "kind": "Variable",
    "name": "externalEventId",
    "variableName": "externalEventId"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalEventId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urnValue",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AsanaTaskEventQuery",
    "selections": [
      {
        "alias": "org",
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "forceFetchEventParentErrorable",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Event",
                        "kind": "LinkedField",
                        "name": "events",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventKey",
                            "kind": "LinkedField",
                            "name": "eventKey",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Attendee",
                            "kind": "LinkedField",
                            "name": "organizer",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "EventParent",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Org",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AsanaTaskEventQuery",
    "selections": [
      {
        "alias": "org",
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "forceFetchEventParentErrorable",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Event",
                        "kind": "LinkedField",
                        "name": "events",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventKey",
                            "kind": "LinkedField",
                            "name": "eventKey",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Attendee",
                            "kind": "LinkedField",
                            "name": "organizer",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "EventParent",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Org",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8952af9db0c75c0e25bb7a4feb626b90",
    "id": null,
    "metadata": {},
    "name": "AsanaTaskEventQuery",
    "operationKind": "query",
    "text": "query AsanaTaskEventQuery(\n  $orgRelayId: ID!\n  $externalEventId: String!\n  $calendarId: String!\n) {\n  org: node(id: $orgRelayId) {\n    __typename\n    id\n    ... on Org {\n      primaryOrgCalendar\n      forceFetchEventParentErrorable(calendarId: $calendarId, externalEventId: $externalEventId) {\n        __typename\n        ... on EventParent {\n          id\n          events {\n            id\n            eventKey {\n              externalEventId\n              id\n            }\n            organizer {\n              urnValue\n              id\n            }\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6ea8cbb25e2a9677dd2866b99510a9fb";

export default node;
